// extracted by mini-css-extract-plugin
module.exports = {"mdBreakPoint":"992","goBackItem":"_2sEblpjnPayMXoEC","arrowBack":"MFrAqGG-cvRvxFTw"};